export function getLoadbalancedProviderApiUrl(): string | null {
  return null;
}

export function getLoadbalancedProxyUrl(): string | null {
  return null;
}
